import { render, staticRenderFns } from "./CmgNutritionCalculatorMetricsSummary.vue?vue&type=template&id=5287b139&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-metrics-summary.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-metrics-summary.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorMetricsSummary.vue?vue&type=style&index=0&id=5287b139&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287b139",
  null
  
)

export default component.exports